export default {
  name: 'marking--orderH',
  apiService: 'shoes',
  apiPath: '/admin/order_h',
};
